<script>
// `~/stores/episode-store` lives outside the editor directory tree.
// See EpisodeLikeAction / EpisodeUpvoteScore for the same pattern.
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";

export default {
  name: "EpisodeDownvoteScore",
  elementPanelSettings: {
    displayName: "Downvote Action",
    displayIcon: "bxs:downvote",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: DynamicComponentActionElement,
  mixins: [EpisodePageElementMixin],
  computed: {
    myValue() {
      return this.getOptionValue(DisplayValue) === "hide" ? "" : this.entity?.downvoteCount ?? 0;
    },
  },
  methods: {
    handleClick() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
